import { keepPreviousData, useQuery } from "@tanstack/react-query";
import type { SearchQuery } from "@mailflare/shared";

import { queryKeys } from "@/lib/query-keys";

import { searchMessages } from "./api";

export type SearchArgs = Partial<SearchQuery> & { readonly q: string };

export function useSearch(args: SearchArgs, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.search(args),
    queryFn: () => searchMessages(args),
    enabled,
    placeholderData: keepPreviousData,
  });
}
